var _style, _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1053_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1054_",
    d: "M9.6,17c-0.54-1.72-0.08-3.58,1.19-4.85l2.4-2.4l1.15,1.15l-2.4,2.4c-0.84,0.84-1.15,2.08-0.79,3.22 L9.6,17z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1051_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1052_",
    d: "M11.78,19.72c-0.36-0.21-0.69-0.46-0.98-0.76C10.25,18.42,9.83,17.74,9.6,17l1.55-0.49 c0.15,0.49,0.42,0.93,0.79,1.3c0.2,0.2,0.41,0.36,0.65,0.5L11.78,19.72z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1049_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1050_",
    d: "M14.2,20.38c-0.83,0-1.67-0.22-2.43-0.66l0.82-1.4c1.25,0.73,2.85,0.53,3.87-0.5l6.97-6.97 c1.25-1.25,1.25-3.27,0-4.52c-1.25-1.25-3.28-1.25-4.52,0l-2.19,2.19l-1.15-1.15l2.19-2.19c1.88-1.88,4.94-1.88,6.82,0 c1.88,1.88,1.88,4.94,0,6.82l-6.97,6.97C16.69,19.9,15.45,20.38,14.2,20.38z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1047_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1048_",
    d: "M14.84,10.78c-0.16-0.48-0.42-0.91-0.78-1.28c-0.2-0.2-0.43-0.38-0.68-0.52l0.8-1.41 c0.37,0.21,0.72,0.48,1.02,0.78c0.54,0.54,0.95,1.2,1.18,1.93L14.84,10.78z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1045_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1046_",
    d: "M4.82,23.56c-1.24,0-2.47-0.47-3.41-1.41c-1.88-1.88-1.88-4.94,0-6.82l6.97-6.97 c1.53-1.53,3.92-1.85,5.8-0.78l-0.8,1.41c-1.25-0.71-2.83-0.5-3.84,0.52l-6.97,6.97c-0.6,0.6-0.94,1.41-0.94,2.26 c0,0.85,0.33,1.66,0.94,2.26c1.25,1.25,3.28,1.25,4.52,0l2.46-2.46l1.15,1.15l-2.46,2.46C7.29,23.09,6.05,23.56,4.82,23.56z"
  })), /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1043_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1044_",
    d: "M12.71,17.67l-1.15-1.15l2.49-2.49c0.85-0.85,1.15-2.1,0.78-3.25l1.55-0.5 c0.56,1.73,0.11,3.61-1.18,4.89L12.71,17.67z"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "Layer_9"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLink);
export default __webpack_public_path__ + "static/media/Link.a7d60e37004f3775fb5db2c5209bbf7f.svg";
export { ForwardRef as ReactComponent };